import React from 'react';

// Demo sections
import DemoModal from './DemoModal';
import DemoForm from './DemoForm';
import DemoSlide from './DemoSlide';
import DemoCards from './DemoCards';

const Demonstration = () => {
  return (
    <div className="">
      <div className="container section-padding">
        <DemoModal />
        <DemoForm />
        <DemoSlide />
        <DemoCards />

        { /* == Table == */}
        <h1 className="text-weight-light sp-xs-top-3 sp-xs-bottom-2 text-accent">Table</h1>
        <div className="row">
          <div className="col-xs-12">
            <table className="table table-radius">
              <thead className="tr-accent">
                <tr>
                  <th>Produto</th>
                  <th>Quantidade</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-grey">
                  <td>Teste</td>
                  <td>1</td>
                  <td>R$480</td>
                </tr>
                <tr>
                  <td>Teste</td>
                  <td>1</td>
                  <td>R$480</td>
                </tr>
                <tr className="bg-grey">
                  <td>Teste</td>
                  <td>1</td>
                  <td>R$480</td>
                </tr>
                <tr>
                  <td>Teste</td>
                  <td>1</td>
                  <td>R$480</td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <td><span className="text-weight-semibold">Subtotal</span></td>
                  <td></td>
                  <td>R$480</td>
                </tr>
                <tr>
                  <td colSpan="2"><span className="text-weight-semibold">Frete</span></td>
                  <td>R$64</td>
                </tr>
                <tr className="bg-grey">
                  <td colSpan="2"><span className="text-weight-semibold">Total</span></td>
                  <td>R$480</td>
                </tr>
                <tr>
                  <td colSpan="2"><span className="text-weight-semibold">Saldo</span></td>
                  <td>R$10</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};

Demonstration.displayName = 'Demonstration';

export default Demonstration;



/** WEBPACK FOOTER **
 ** ./src/components/demo/Demonstration.js
 **/